(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elsniva-moments"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elsniva-moments')){
customElements.define('elsniva-moments',class extends HTMLElement{
connectedCallback(){
this.viewport=this.querySelector('.elsniva-moments__viewport');
this.track=this.querySelector('.elsniva-moments__track');
this.button=this.closest('section').querySelector('[data-pause]');
this.abort=new AbortController();
const options={signal:this.abort.signal};
this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.hovered=false;this.interacting=false;this.visible=false;
this.originals=[...this.track.children];
this.originals.forEach(item=>{const copy=item.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.removeAttribute('data-shopify-editor-block');this.track.append(copy)});
this.updateButton=()=>{this.button.textContent=this.paused?this.dataset.playLabel:this.dataset.pauseLabel;this.button.setAttribute('aria-pressed',String(this.paused))};
this.updateButton();
this.button.addEventListener('click',()=>{this.paused=!this.paused;this.updateButton()},options);
this.viewport.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hovered=true},options);
this.viewport.addEventListener('pointerleave',()=>{this.hovered=false},options);
this.viewport.addEventListener('pointerdown',()=>{this.paused=true;this.updateButton()},options);
this.viewport.addEventListener('focusin',()=>{this.interacting=true},options);
this.viewport.addEventListener('focusout',()=>{this.interacting=false},options);
this.viewport.addEventListener('wheel',()=>{this.paused=true;this.updateButton()},options);
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting});
this.observer.observe(this);
let last=0;let position=this.viewport.scrollLeft;
const tick=time=>{
const elapsed=last?Math.min(time-last,40):0;last=time;
if(this.visible&&!this.paused&&!this.hovered&&!this.interacting&&!document.hidden){
const boundary=this.track.children[this.originals.length].offsetLeft-this.track.children[0].offsetLeft;
position+=elapsed*.024;
if(boundary&&position>=boundary)position-=boundary;
this.viewport.scrollLeft=position;
}else{position=this.viewport.scrollLeft}
this.frame=requestAnimationFrame(tick);
};
this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.abort?.abort();this.observer?.disconnect();this.track?.querySelectorAll('[aria-hidden="true"]').forEach(el=>el.remove())}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function setupSzykFooterAccordions(root) {
    const desktop = window.matchMedia('(min-width: 700px)');
    root.querySelectorAll('.szyk-footer-accordion').forEach((details) => {
      if (details.dataset.szykInitialized) return;
      details.dataset.szykInitialized = 'true';
      const sync = () => { details.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
      details.querySelector('summary')?.addEventListener('click', (event) => {
        if (desktop.matches) event.preventDefault();
      });
    });
  }
  setupSzykFooterAccordions(document);
  document.addEventListener('shopify:section:load', (event) => setupSzykFooterAccordions(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["szyk-privacy"]) return;
  try {
    
document.querySelectorAll('[data-szyk-privacy]').forEach(function(form){
  const status=form.querySelector('[role="status"]');
  const button=form.querySelector('button');
  if(!window.Shopify||!Shopify.loadFeatures){status.textContent=form.dataset.error;return;}
  Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
    if(error||!Shopify.customerPrivacy){status.textContent=form.dataset.error;return;}
    const consent=Shopify.customerPrivacy.currentVisitorConsent();
    ['preferences','analytics','marketing'].forEach(function(name){form.elements[name].checked=consent[name]==='yes';});
    button.disabled=false;
  });
  form.addEventListener('submit',function(event){
    event.preventDefault();
    if(button.disabled)return;
    button.disabled=true;
    const consent={preferences:form.elements.preferences.checked,analytics:form.elements.analytics.checked,marketing:form.elements.marketing.checked};
    Shopify.customerPrivacy.setTrackingConsent(consent,function(result){
      status.textContent=result&&result.error?form.dataset.error:form.dataset.success;
      button.disabled=false;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
